import styled from "styled-components"


export const Sidediv=styled.div`
height:450px;
width:330px;
margin-top:1px;
display: flex;
flex-direction: column;
text-align: center;
`

export const Sidediv1=styled.div`
height:500px;
width:350px;
display: flex;
flex-direction: column;
justify-content: center;
text-align: center;
margin-left:55px;
background-color: #F9F9F9;
`